import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Autocomplete from "@mui/material/Autocomplete";

import {
  fetchAllRoles,
  getDivision,
  getManagerId,
  getReportingManagerDesignation,
} from "../../services/userService";
import {
  modelDataType,
  personalDetailsType,
  userDivisionType,
  userOverviewType,
  userModalFormType,
  Role,
} from "./userModalType";
import { validDateEmail, validDateMobile } from "../../utils/utils";
import GenricMultiSelect from "../Input/GenericMultiSelect";
import { userModalType } from "../../features/editAndView/ViewAndEditType";
import { Field, LocationOutletInformationProps, OutletInformationProps } from "../ouletModal/OutletModalTypes";
import { outletMetaData } from "../../features/editAndView/ViewAndEditType";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import GenericFileUpload from "../genericFileUpload/GenericFileUpload";
import store from "../../stateManagement/store";
import { Switch } from "@mui/material";

const UserOverview = ({
  submit: { check, setCheck },
  userInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  disableEdit 
}: userOverviewType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const [division, setDivision] = useState<userDivisionType[]>();

  const [reportingManager, setReportingManager] =
    useState<userDivisionType[]>();

  const [managerId, setManagerId] = useState();

  const [currentUserLevel, setCurrentUserLevel] = useState(0);
  const [selectedRoles,setSelectedRoles] = useState(defaultInputs?.roles?.map((roleObj) => roleObj.name) ?? [])
  const [roleOptions,setRoleOptions] = useState<string[]>([]);

  useEffect(() => {
    const defaultReportingManager = async () => {
      if (defaultInputs.immediateParent) {
        const response = await getReportingManagerDesignation(
          defaultInputs.immediateParent.split(",")[0]
        );
        const byDefaultReportingManager = response.data.features[0].designation[0];
        setDefaultInputs((prev: userModalFormType) => ({
          ...prev,
          "reportingManager": byDefaultReportingManager,
        }))
      }
    };
    const getSynchronus = async () => {
      await getDivisionsData();
      const roleArr = await fetchAllRoles();
      const allRoles = roleArr.map((roleObj: Role) => roleObj.name);
      setRoleOptions(allRoles);
      if(!check){
        await defaultReportingManager();
      }
    };
    getSynchronus();
  }, []);

  useEffect(() => {
    const reportingManager = division?.filter((item) => {
      return item.divisionLevel < currentUserLevel;
    });
    setReportingManager(reportingManager);
  }, [currentUserLevel]);

  useEffect(() => {
    const getManagerIdsData = async () => {
      if (defaultInputs.reportingManager) {
        const allManagers = await getManagerId(defaultInputs.reportingManager);
        setManagerId(allManagers);
      }
    };
    getManagerIdsData();
  }, [defaultInputs.reportingManager]);

  const getDivisionsData = async () => {
    const response = await getDivision();
    await setDivision(response);
  };

  const getDefaultReportingManger = async () => {
    division?.forEach((item: userDivisionType) => {
      if (
        defaultInputs.designation &&
        defaultInputs.designation[0] === item.divisionName
      ) {
        const level = item.divisionLevel;
        setCurrentUserLevel(level);
      }
    });
  };

  return (
    <div className="model-child">
      <TextField
        label={translate("User","Login_id" )}
        id="outlined-start-adornment"
        value={defaultInputs.loginId}
        disabled={true}
      />
      <Autocomplete
        value={
          defaultInputs.designation
            ? defaultInputs.designation[0]
            : "Select division field"
        }
        disablePortal
        disabled={true}
        options={
          division
            ? division.map((item) => {
              return item.divisionName;
            })
            : []
        }
        sx={{ width: "100%" }}
        renderInput={(params) => <TextField {...params} label={translate("User","Division" )}/>}
        onChange={(event, value: string | null) => {
          division?.forEach((item: userDivisionType) => {
            if (value === item.divisionName) {
              const level = item.divisionLevel;
              setCurrentUserLevel(level);
              setCheck(true);
            }
          });
          const helper: userModalFormType = defaultInputs;
          helper.designation = [value ? value : ""];
          helper.immediateParent = "";
          helper.reportingManager = "";
          setDefaultInputs((prev: userModalFormType) => ({
            ...prev,
            ...helper,
          }));
          setEditRequestBody((prev: userModalFormType) => ({
            ...prev,
            "designation": [value ? value : ""],
          }));
        }}
      />
      <Autocomplete
        value={
          defaultInputs.reportingManager
            ? defaultInputs.reportingManager
            : "Select reporting Manager"
        }
        disablePortal
        disabled={true}
        options={
          reportingManager
            ? reportingManager.map((item) => {
              return item.divisionName;
            })
            : []
        }
        sx={{ width: "100%" }}
        renderInput={(params) => (
          <TextField {...params} label= {translate("User","Reporting Manager")}/>
        )}
        onOpen={async () => {
          await getDefaultReportingManger();
        }}
        onChange={(event, value: string | null) => {
          if (value) {
            setEditRequestBody((prev: userModalFormType) => ({
              ...prev,
              "reportingManager": value,
            }));
            setDefaultInputs((prev: userModalFormType) => ({
              ...prev,
              "reportingManager": value,
            }));
            setCheck(true);
          }
        }}
      />
      {/* <Autocomplete
        value={
          defaultInputs.immediateParent
            ? defaultInputs.immediateParent.split(',')[0]
            : "Select Manager Id"
        }
        disablePortal
        disabled={true}
        options={managerId ? managerId : []}
        sx={{ width: "100%" }}
        renderInput={(params) => <TextField {...params} label={translate("User","ManagerID" )} />}
        onChange={(event, value: string | null) => {
          if (value) {
            setEditRequestBody((prev: userModalFormType) => ({
              ...prev,
              "immediateParent": value,
            }));
            setDefaultInputs((prev: userModalFormType) => ({
              ...prev,
              "immediateParent": value,
            }));
            setCheck(true);
          }
        }}
      /> */}
      <GenricMultiSelect
        disable={true}
        limitTags={20}
        className=""
        options={managerId ? managerId : []}
        label={translate("User", "ManagerID")}
        selectedOptions={
          defaultInputs.immediateParent
            ? defaultInputs.immediateParent.split(',')
            : []
        }
        handleMultiSelectState={(selectedOptions) => {
          if (selectedOptions.length > 0) {
            const selectedParents = selectedOptions.join(',');

            setEditRequestBody((prev: userModalFormType) => ({
              ...prev,
              immediateParent: selectedParents,
            }));

            setDefaultInputs((prev: userModalFormType) => ({
              ...prev,
              immediateParent: selectedParents,
            }));

            setCheck(true);
          }
        }}
        isRequired={false}
      />
      <GenricMultiSelect 
        disabled={disableEdit} 
        className="" 
        options={roleOptions} 
        label={translate("User","Roles" )}
        selectedOptions = {selectedRoles} 
        handleMultiSelectState={(selectedOptions) => {
          setSelectedRoles(selectedOptions);
          const rolesArr = selectedOptions.map((roleName) => {
            return {
              name: roleName 
            }
          });
          setDefaultInputs((prev: userModalFormType) => ({
            ...prev,
            "roles": rolesArr 
          }));
          setEditRequestBody((prev: userModalFormType) => ({
            ...prev,
            "roles": rolesArr
          }));
          setCheck(true);
        }} 
        isRequired={false}
      />

      <FormLabel sx={{ marginLeft: 1 }} >
      {translate("User","Status" )}
      </FormLabel>
      <RadioGroup
        sx={{ m: 1 }}
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={defaultInputs.activeStatus}
        onChange={(event, value) => {
          setDefaultInputs((prev: userModalFormType) => ({
            ...prev,
            "activeStatus": value
          }));
          setEditRequestBody((prev: userModalFormType) => ({
            ...prev,
            activeStatus: value,
          }));
          setCheck(true);
        }}
      >
        <FormControlLabel value="active" disabled={true} control={<Radio />} label={translate(TranslationEnum.common_portal,"Active")} />
        <FormControlLabel
          value="inactive"
          disabled={disableEdit} 
          control={<Radio />}
          label={translate(TranslationEnum.common_portal,"Non Active")}
        />
      </RadioGroup>
    </div>
  );
};

const PersonalDetails = ({
  submit: { check, setCheck },
  userInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  validEmail: { validEmail, setValidEmail },
  validMobile: { validMobile, setValidMobile },
  disableEdit 
}: personalDetailsType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const checkEmail = (value: string | "") => {
    setValidEmail(validDateEmail(value));
  }

  const checkMobile = (value: string | "") => {
    setValidMobile(validDateMobile(value));
  }

  return (
    <div className="model-child">
      <TextField
        label={translate("User","Name" )}
        sx={{ width: "100%" }}
        value={defaultInputs.name}
        disabled={true}
      />
      <TextField
        label={translate("User","email" )}
        sx={{ width: "100%" }}
        value={defaultInputs.email}
        onChange={(e) => {
          setDefaultInputs((prev: userModalFormType) => ({
            ...prev,
            "email": e.target.value
          }));
          setEditRequestBody((prev: userModalFormType) => ({
            ...prev,
            email: e.target.value,
          }));
          checkEmail(e.target.value)
          setCheck(true);
        }}
        error={!validEmail}
        helperText={validEmail || "Please enter a valid email."}
        disabled={disableEdit}
      />
      <TextField
        label={translate("User","Mobile" )}
        sx={{ width: "100%" }}
        value={defaultInputs.mobile}
        onChange={(e) => {
          setDefaultInputs((prev: userModalFormType) => ({
            ...prev,
            "mobile": e.target.value,
          }));
          setEditRequestBody((prev: userModalFormType) => ({
            ...prev,
            "mobile": e.target.value,
          }));
          checkMobile(e.target.value);
          setCheck(true);
        }}
        error={!validMobile}
        helperText={validMobile || "Please enter a valid Phone no"}
        disabled={disableEdit} 
      />
    </div>
  );
};

const UserLocation = ({ modelData }: { modelData: modelDataType }) => {
  return (
    <div className="model-child">
      <TextField label="Country" />
      <div className="model-select">
        <Autocomplete
          disablePortal
          options={[]}
          sx={{ width: "49%" }}
          renderInput={(params) => <TextField {...params} label="Region" />}
        />
        <Autocomplete
          disablePortal
          options={[]}
          sx={{ width: "49%" }}
          renderInput={(params) => <TextField {...params} label="City" />}
        />
      </div>
    </div>
  );
};

const LocationInformation = ({
  userInputs: { defaultInputs, setDefaultInputs }
}: any) => {
  var DL = defaultInputs.locationHierarchy.split(">");
  const branch = DL[0];
  const district = DL[1]
  return (
    <div className="model-child">
      <TextField disabled={true} label="District" value={district} />
      <TextField disabled={true} label="Branch" value={branch} />
    </div>
  );
};

const UserInformation = ({
  userInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  submit: { check, setCheck },
}: any) => {
  return (
    <div className="model-child">
      <div className="model-row">
        <TextField label="Name" disabled={true} value={defaultInputs.name} />
        <TextField label="WD Code" disabled={true} value={defaultInputs.extendedAttributes.WDCode} />
      </div>
      <div className="model-row">
        <TextField label="WD Dest Code" disabled={true} value={defaultInputs.extendedAttributes.WDCode} />
        <TextField label="Designation" disabled={true} value={defaultInputs.designation} />
      </div>
      <div className="model-row">
        <TextField label="Mobile Number" disabled={true} value={defaultInputs.mobile} />
        <TextField label="Min Order Value" type="number" onChange={(e) => {
          setDefaultInputs((prev: { supplierMetaData: any[]; }) => ({
            ...prev,
            supplierMetaData: [
              {
                ...prev.supplierMetaData[0],
                min: e.target.value
              }
            ]
          }));
          setEditRequestBody((prev: { supplierMetaData: any[]; }) => {
            return {
              ...prev,
              supplierMetaData: [
                {
                  ...prev?.supplierMetaData?.[0],
                  min: e.target.value
                }
              ]
            }
          });
          setCheck(true);
        }} value={defaultInputs.supplierMetaData[0].min} />
      </div>
      <div className="model-row">
        <TextField label="Active" disabled={true} value={defaultInputs.activeStatus} />
        <TextField label="Email" disabled={true} value={defaultInputs.immediateParent} />
      </div>
      <div className="model-row">
        <TextField label="Vajra SFA Ver" disabled={true} value={defaultInputs.extendedAttributes.vajraSFAVersion} />
        <TextField label="Type" disabled={true} value={defaultInputs.extendedAttributes.WDType} />
      </div>
      <div className="model-row">
        <TextField label="Lat" disabled={true} value={defaultInputs.extendedAttributes.gps_latitude} />
        <TextField label="Long" disabled={true} value={defaultInputs.extendedAttributes.gps_longitude} />
      </div>
      <TextField label="Order Fulfillment Time" type="number" onChange={(e) => {
        setDefaultInputs((prev: { extendedAttributes: any; }) => ({
          ...prev,
          extendedAttributes: {
            ...prev.extendedAttributes,
            orderFulfillmentTime: e.target.value
          }
        }));
        setEditRequestBody((prev: { extendedAttributes: any; }) => ({
          ...prev,
          extendedAttributes: {
            ...prev?.extendedAttributes,
            orderFulfillmentTime: e.target.value
          },
          supplierMetaData: [defaultInputs.supplierMetaData[0]]
        }));
        setCheck(true);
      }} value={defaultInputs.extendedAttributes.orderFulfillmentTime} />
    </div>
  );
};


const getFieldValue = (id: string, defaultInputs: outletMetaData, toFindIn?: string,) => {
  if (toFindIn) {
    const filedArrays = toFindIn.split(".");
    var initial: any = defaultInputs;
    filedArrays.forEach((subStringpart: string) => {
      if (!initial) {
        return;
      }
      initial = initial[subStringpart as keyof outletMetaData];
    });
    return initial;
  }
  if (id === 'branch') {
    var DL: any = defaultInputs?.location?.split(">");
    const branch = DL[0];
    return branch;
  } else if (id === 'district') {
    var DL: any = defaultInputs?.location?.split(">");
    const district = DL[1];
    return district;
  } else {
    return defaultInputs[id as keyof outletMetaData];
  }
};

const handleChange = (id: string, setDefaultInputs: any, setCheck: React.Dispatch<React.SetStateAction<boolean>>, newValue: string,setValidMobile: React.Dispatch<React.SetStateAction<boolean>>, setEditRequestBody?: any) => {
  const {userNameKey} = store.getState().mdmReducer;
  setDefaultInputs((prevModelData: any) => {
    return { ...prevModelData, [id]: newValue };
  });
  const contactNumberPattern = /^\d{10}$/;
  if (id === 'contactno' && !contactNumberPattern.test(newValue)) {
    const isValidMobile = contactNumberPattern.test(newValue);
    if(newValue.length!==0){
      setValidMobile(isValidMobile);
    if (!isValidMobile) {
        setCheck(false);
        return;
    }
    }
  }
  setEditRequestBody((prev: any) => ({
    ...prev,
    [id]: newValue,
    ...(userNameKey && {
      "userName": {
        ...prev.userName,
        "mobile": newValue
      }
    })
  }));
  setValidMobile(true)
  setCheck(true);
};

const handleReject = (id: string, setDefaultInputs: any, setCheck: React.Dispatch<React.SetStateAction<boolean>>, newValue: string, setEditRequestBody?: any) => {
  setDefaultInputs((prevModelData: any) => {
    return { ...prevModelData, [id]: newValue };
  });
  const localStorageValue = localStorage.getItem("authContext");
  let role: string = ""
  if (localStorageValue !== null) {
    role = JSON.parse(localStorageValue).user?.designation?.[0];
  }
  setEditRequestBody((prev: any) => ({
    ...prev,
    extendedAttributes: {
      ...prev.extendedAttributes,
      remark: newValue,
      role: role,
      status: "Rejected"
    }
  }));
  if(newValue.length && newValue.length>0){
    setCheck(true);
  }else{
    setCheck(false);
  }
};

const GenericModalInformation: React.FC<LocationOutletInformationProps> = ({ setEditRequestBody, defaultInputs, setDefaultInputs, setCheck, fields ,validMobile: { validMobile, setValidMobile },setDefaultImageUrl,defaultImageUrl,fileName,setFileName}) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "GenericModal"
  function setBlobkey(blobKey: any){
    setDefaultImageUrl(blobKey)
    setCheck(true)
  }
  function setFileAttributes(uploadedFileAtributes: any){
   setFileName(uploadedFileAtributes.fileName)
  }
  const imageField = fields.find(field => field.id === "image");
  const acceptType = imageField ? imageField.acceptType : null;
  return (
    <div style={{ margin: "2%", gap: "2rem" }}>
      <div className="model-child">
        {fields.map((field: Field) => (
          <React.Fragment key={field.label}>
            {field.type === "textfield" && (
              <TextField
                label={translate(TranslationEnum.generic_modal,field.label)}
                value={getFieldValue(field.id, defaultInputs, field.toFindIn)}
                disabled={field.disabled === "true"}
                onChange={field.disabled === "false" ? (e: React.ChangeEvent<HTMLInputElement>) => handleChange(field.id, setDefaultInputs, setCheck, e.target.value,setValidMobile, setEditRequestBody) : undefined}
                error={field.id === 'contactno' && !validMobile}
                helperText={field.id === 'contactno' && !validMobile && "Please enter a valid Phone no"}
              />
            )}
            {field.type === "description" && (
              <TextField
                label={field.label}
                value={getFieldValue(field.id, defaultInputs, field.toFindIn)}
                disabled={field.disabled === "true"}
                onChange={field.disabled === "false" ? (e: React.ChangeEvent<HTMLTextAreaElement>) => handleReject(field.id, setDefaultInputs, setCheck, e.target.value, setEditRequestBody) : undefined}
                multiline
                rows={4}
                variant="outlined"
              />
            )}
        {field.type === "image" && <GenericFileUpload
              resolution={{ width: 500, height: 500 }}
              label={translate(TranslationEnum.common_portal,"Upload Image")}
              defaultFile={defaultImageUrl}
              setDefaultFile={setBlobkey} 
              accept={acceptType}
              fileAttributes={{
                fileName: fileName
              }}
              setFileAttributes={setFileAttributes}
              fetchBlobKey={true}
            />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

const LocationDetails = ({
  submit: { check, setCheck },
  userInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  validEmail: { validEmail, setValidEmail },
  validMobile: { validMobile, setValidMobile },
}: any) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  return (
    <div className="model-child">
      <TextField
        label={translate("User","Country" )}
        sx={{ width: "100%" }}
        value={defaultInputs.locationHierarchy.split(" > ").pop()}
        disabled={true}
      />
       <TextField
        label={translate("User","District" )}
        sx={{ width: "100%" }}
        value={defaultInputs.extendedAttributes.District}
        disabled={true}
      />
       <TextField
        label={translate("User","Branch" )}
        sx={{ width: "100%" }}
        value={defaultInputs.extendedAttributes.Branch}
        disabled={true}
      />
    </div>
  );
};

const OtherDetails = ({
  submit: { check, setCheck },
  userInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  validEmail: { validEmail, setValidEmail },
  validMobile: { validMobile, setValidMobile },
}: any) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked ? 'Y' : 'N'; 

    setDefaultInputs((prev:any) => ({
      ...prev,
      extendedAttributes: {
        ...prev.extendedAttributes,
        AUS: newValue
      }
    }));

    setEditRequestBody((prev:any) => ({
      ...prev,
      extendedAttributes: {
        ...prev.extendedAttributes,
        AUS: newValue
      },
      immediateParent: defaultInputs.immediateParent,
      reportingManager: defaultInputs.reportingManager
    }));
    setCheck(true)
  };

  return (
    <div className="model-child">
       <TextField
        label={translate("User","DSType" )}
        sx={{ width: "100%" }}
        value={defaultInputs.extendedAttributes.DSType}
        onChange={(e) => {
          setDefaultInputs((prev: { extendedAttributes: any; }) => ({
            ...prev,
            extendedAttributes: {
              ...prev.extendedAttributes,
              DSType: e.target.value
            }
          }));
          setEditRequestBody((prev: { extendedAttributes: any; }) => ({
            ...prev,
            DSType: e.target.value,
            immediateParent: defaultInputs.immediateParent,
            reportingManager: defaultInputs.reportingManager
          }));
          setCheck(true);
        }}
      />
       <FormControlLabel
      control={
        <Switch
          checked={defaultInputs.extendedAttributes.AUS === 'Y'} 
          onChange={handleToggle} 
        />
      }
      label={translate("User", "AUS")}
    />
    </div>
  );
};

export { UserOverview, PersonalDetails, UserLocation, LocationInformation, UserInformation, GenericModalInformation,LocationDetails,OtherDetails };
